.imageContainer {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: var(--cxy-z-index-internal-base);
}

.imageContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

.overlay {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(5, 38, 67, 0) 0%, #010d17 99.57%);
  z-index: var(--cxy-z-index-internal-mid);
}

@container (min-width: 480px) {
  .overlay {
    display: block;
  }
}

/* Focus position modifiers */
.focusTopLeft img {
  object-position: top left;
}

.focusTopCenter img {
  object-position: top center;
}

.focusTopRight img {
  object-position: top right;
}

.focusCenterLeft img {
  object-position: center left;
}

.focusCenter img {
  object-position: center center;
}

.focusCenterRight img {
  object-position: center right;
}

.focusBottomLeft img {
  object-position: bottom left;
}

.focusBottomCenter img {
  object-position: bottom center;
}

.focusBottomRight img {
  object-position: bottom right;
}

.overlay.noOverlay,
.noOverlay {
  display: none;
}
